import React, { useEffect, useState } from "react";
import medicine from "../assets/icons/medicine.webp";
import CommonTitle from "../components/CommonTitle";
import Filters from "../components/Filters";
import FilterItem from "../components/FilterItem";
import MedicineListTable from "../components/med_list/MedicineListTable";
import TableStructure from "../components/TableScruture";
import { getSuppliesByPage } from "../services/medicines";
import LoadingPage from "../components/LoadingPage";
import ModalStructure from "../components/ModalStructure";
import NewSupplieForm from "../components/med_list/NewSupplieForm";
import { MdAdd } from "react-icons/md";
import { IS_LOCAL_ENV } from "../App";
import Notification from "../components/ui-elements/Notification";
//filters

const uamSelectOptions = [
  { text: "Miligramos (mg)", value: "1" },
  { text: "Gramos (g)", value: "2" },
  { text: "Microgramos (µg)", value: "3" },
  { text: "Mililitros (mL)", value: "4" },
  { text: "Centímetros cúbicos (cc)", value: "5" },
  { text: "Unidades internacionales (UI)", value: "6" },
  { text: "Porcentaje (%)", value: "7" },
  { text: "MiliEquivalentes (mEq)", value: "8" },
  { text: "Pipas (ppt)", value: "9" },
];

const presSelectOptions = [
  { text: "Tabletas (comprimidos)", value: "1" },
  { text: "Cápsulas", value: "2" },
  { text: "Polvos", value: "3" },
  { text: "Píldoras", value: "4" },
  { text: "Jarabes", value: "5" },
  { text: "Suspensiones", value: "6" },
  { text: "Soluciones", value: "7" },
  { text: "Gotas", value: "8" },
  { text: "Inyecciones", value: "9" },
  { text: "Cremas y ungüentos", value: "10" },
  { text: "Pomadas", value: "11" },
  { text: "Geles", value: "12" },
  { text: "Sprays", value: "13" },
  { text: "Inhaladores", value: "14" },
  { text: "Nebulizadores", value: "15" },
  { text: "Parche transdérmico", value: "16" },
  { text: "Supositorios", value: "17" },
  { text: "Implantes", value: "18" },
  { text: "Viales", value: "19" },
  { text: "Ampollas", value: "20" },
  { text: "Blíster", value: "21" },
  { text: "Frascos", value: "22" },
  { text: "Cajas", value: "23" },
];
/*Bioestimulante
Fertilizante
Micronutrientes
Enraizante
Nutrientes
Agua
Fumigacion
sabila*/

const MedicineList = () => {
  const [showModal, setShowModal] = useState(false);
  //==================filtros===========================
  const [loadingFilter, setLoadingFilter] = useState(false);

  const [selectPropsList, setSelectPropsList] = useState([
    {
      isInput: true,
      title: "Nombre",
      value: "",
      onChange: (e) => updateSelectProp(0, e),
      placeholder: "Buscar nombre",
      inputType: "text",
      formatedValue: (val) => val,
      dbField: "sName",
    },
    {
      isInput: true,
      title: "Cliente",
      value: "",
      onChange: (e) => updateSelectProp(1, e),
      placeholder: "Buscar cliente",
      inputType: "text",
      formatedValue: (val) => val,
      dbField: "cName",
    },
    {
      isInput: true,
      title: "Cantidad",
      value: "",
      onChange: (e) => updateSelectProp(2, e),
      placeholder: "Buscar cantidad",
      inputType: "number",
      formatedValue: (val) => parseFloat(val),
      dbField: "quantity",
    },
  ]);

  const updateSelectProp = (i, e) => {
    setSelectPropsList((prev) => {
      let temp = [...prev];
      temp[i].value = e.target.value;
      return temp;
    });
  };

  const [filterQueryObject, setFilterQueryObject] = useState({});

  //=================================================================
  const [loading, setLoading] = useState(true);
  const [supplies, setSupplies] = useState([]);
  //=========pagination props====================
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  //==========sort prop==========================
  const [sortedProp, setSortedProp] = useState(null); //ej "name" o "-name"
  const [showTableLoader, setShowTableLoader] = useState(false);
  //=======================fetch data=======================
  useEffect(() => {
    const fetcSupplies = async () => {
      try {
        setShowTableLoader(true);
        const response = await getSuppliesByPage(
          currentPage,
          sortedProp,
          filterQueryObject
        );
        IS_LOCAL_ENV && console.log(response.docs);
        if (!response?.docs?.length === 0) {
          Notification({
            title: "Aviso",
            text: `Aún no hay Medicinas disponibles`,
            type: "Info",
          });
          setLoading(false);
          setShowTableLoader(false);
          return;
        } else {
          setSupplies(response.docs);
          setTotalPages(response.totalPages);
          setLoading(false);
          setLoadingFilter(false);
          setShowTableLoader(false);
        }
      } catch (error) {
        Notification({
          title: "Operación inválida",
          text: `Ingrese un url válido o completa todos los campos`,
          type: "Error",
        });
        setLoadingFilter(false);
        setLoading(false);
        IS_LOCAL_ENV && console.log(error);
      }
    };
    fetcSupplies();
  }, [currentPage, sortedProp, filterQueryObject]);

  //====================filters================================

  const applyFilters = () => {
    let temp = [];

    temp = selectPropsList
      .filter((filter) => filter.value != "")
      .map((filter) => ({
        [filter.dbField]: {
          [filter.dbField == "quantity" ? "equals" : "like"]:
            filter.formatedValue(filter.value),
        },
      }));

    const filterQuery =
      temp.length > 1 ? { and: temp } : temp.length === 1 ? temp[0] : {};

    setFilterQueryObject(filterQuery);
  };

  return (
    <div className="w-full h-full flex flex-col">
      <CommonTitle
        img={medicine}
        title={"Lista de medicina"}
        text={
          "Visualiza y administra cada medicina predispuesta para las orquídeas Phalaenopsis."
        }
      >
        {showModal && (
          <ModalStructure
            handleCloseModal={() => setShowModal(false)}
            customMaxW="max-w-[470px]"
          >
            <NewSupplieForm
              handleClose={() => setShowModal(false)}
              addNewSupplie={(newSupplie) =>
                setSupplies((prevData) => [...prevData, newSupplie])
              }
            />
          </ModalStructure>
        )}
        <button
          className={` w-fit bg-dark-green text-base m-4 rounded-full py-4 px-6 text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins `}
          onClick={() => setShowModal(true)}
        >
          <div className="flex flex-row items-center">
            <span className="text-nowrap">Añadir Medicina</span>
            <MdAdd />
          </div>
        </button>
      </CommonTitle>
      {loading ? (
        <LoadingPage />
      ) : (
        <>
          <Filters applyFilters={applyFilters}>
            {!loadingFilter &&
              selectPropsList.map((props, i) => {
                return <FilterItem props={props} key={i} />;
              })}
          </Filters>
          <TableStructure
            showTableLoader={showTableLoader}
            paginationProps={{ currentPage, setCurrentPage, totalPages }}
          >
            <MedicineListTable
              _data={supplies}
              uamSelectOptions={uamSelectOptions}
              presSelectOptions={presSelectOptions}
              updateSortedProp={(str) => setSortedProp(str)}
            />
          </TableStructure>
        </>
      )}
    </div>
  );
};

export default MedicineList;
